var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { v4 as uuidv4 } from "uuid";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ActionCreators as UndoActionCreators } from "redux-undo";
import { getInitialTubeDiameterIndex } from "./scene/helpers";
import { isCentralizedSystem } from "./system-data/helpers";
import { GripPositionMarkerId, NodeComponentType, tubeDiameterOptions, TubeType, UnitSystem, } from "store/types";
import * as sceneReducer from "store/scene/reducer";
import * as systemDataReducerDefineParameters from "store/system-data/define-parameters/reducer";
import * as systemDataReducerSelectApplication from "store/system-data/select-application/reducer";
import * as uiReducer from "store/ui/reducer";
import * as systemPerformanceReducer from "store/system-performance/reducer";
import * as userReducer from "store/user/reducer";
import * as undoSnapshotsReducer from "store/undo-snapshots/reducer";
import { getCommittedSelectionIds, getNodeSelectionSnapshot, nodeHasAnySelection, } from "store/undo-snapshots/helpers";
import { ComponentList } from "api/tacton/types";
import { feedPressurePointNodeId, feedPressurePointPlaceholderName, } from "3d/constants/common";
import { persistConfig as uiPersistConfig } from "store/ui/persist-config";
import { getPairsToConnect } from "store/auto-routing";
import { selectAttachments, selectCentralizedPumps, selectEdges, selectFeedPressurePoints, selectGripPositions, selectTubeConnections, } from "store/scene/selectors";
import { clearPersistedStorage, persist, persistTemplate, rehydrate, } from "store/persist";
var toggleGraphPanel = function (open) {
    return function (dispatch) {
        dispatch(uiReducer.internalActions.toggleGraphPanel(open));
    };
};
var checklistActionAddPump = function () { return function (dispatch, getState) {
    var state = getState();
    var systemDataDefineParameters = state.systemDataDefineParameters;
    var systemData = systemDataDefineParameters.dataState.data;
    if (!systemData)
        return;
    var isSystemCentralized = isCentralizedSystem(systemData);
    if (isSystemCentralized) {
        dispatch(addCentralizedPump());
    }
    else {
        dispatch(_selectGripPositionWithoutPumpSelection());
    }
}; };
var checklistActionSelectCup = function () { return function (dispatch) {
    dispatch(_selectGripPositionWithoutCupSelection());
}; };
var _selectGripPositionWithoutPumpSelection = function () { return function (dispatch) {
    dispatch(_selectGripPositionWithoutSelectedComponent("vacuumPumpSelectionsDecentralized", "pumpSelectionDecentralMap"));
}; };
var _selectGripPositionWithoutCupSelection = function () { return function (dispatch) {
    dispatch(_selectGripPositionWithoutSelectedComponent("suctionCupSelections", "cupSelectionMap"));
}; };
var _selectGripPositionWithoutSelectedComponent = function (systemDataKey, defineParametersKey) {
    return function (dispatch, getState) {
        var e_1, _a;
        var state = getState();
        var systemDataDefineParameters = state.systemDataDefineParameters;
        var systemData = systemDataDefineParameters.dataState.data;
        if (!systemData)
            return;
        var sceneState = state.scene.present;
        var nodes = sceneState.nodes;
        var selections = systemData[systemDataKey];
        var selectionMap = systemDataDefineParameters[defineParametersKey];
        var gripPositionWithNoSelectionId;
        try {
            for (var _b = __values(Object.values(nodes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var node = _c.value;
                var isGripPosition = node.type === NodeComponentType.GRIP_POSITION;
                if (!isGripPosition)
                    continue;
                var nodeId = node.id;
                var selectionId = selectionMap[nodeId];
                var selectedComponent = selectionId && selections[selectionId];
                if (selectedComponent)
                    continue;
                gripPositionWithNoSelectionId = nodeId;
                break;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (gripPositionWithNoSelectionId) {
            dispatch(uiReducer.callableActions.selectEntity(gripPositionWithNoSelectionId));
        }
    };
};
var addGripPosition = function () { return function (dispatch, getState) {
    var _a;
    var nodeId = "grip-position-".concat(uuidv4());
    dispatch(systemDataReducerDefineParameters.internalActions.assignCupSelection(nodeId));
    dispatch(systemDataReducerDefineParameters.internalActions.assignCupMountingSelection(nodeId));
    dispatch(systemDataReducerDefineParameters.internalActions.assignDecentralPumpSelection(nodeId));
    var hasCupTechnologies = Object.keys(((_a = getState().systemDataDefineParameters.dataState.data) === null || _a === void 0 ? void 0 : _a.cupTechnologySelections) || {}).length > 0;
    if (hasCupTechnologies) {
        dispatch(systemDataReducerDefineParameters.internalActions.assignCupTechnologySelection(nodeId));
    }
    var systemDataDefineParameters = getState().systemDataDefineParameters;
    if (!systemDataDefineParameters.cupSelectionMap[nodeId] ||
        !systemDataDefineParameters.cupMountingSelectionMap[nodeId] ||
        (hasCupTechnologies &&
            !systemDataDefineParameters.cupTechnologySelectionMap[nodeId]) ||
        !systemDataDefineParameters.pumpSelectionDecentralMap[nodeId]) {
        dispatch(systemDataReducerDefineParameters.internalActions.unassignAllSelections([
            nodeId,
        ]));
        return;
    }
    dispatch(sceneReducer.internalActions.addGripPosition(nodeId));
    dispatch(uiReducer.callableActions.selectEntity(nodeId));
}; };
var addCentralizedPump = function () { return function (dispatch, getState) {
    if (getState().systemDataDefineParameters.dataState.isLoading)
        return;
    var nodeId = "central-pump-".concat(uuidv4());
    dispatch(systemDataReducerDefineParameters.internalActions.assignCentralPumpSelection(nodeId));
    if (!getState().systemDataDefineParameters.pumpSelectionCentralMap[nodeId]) {
        return;
    }
    dispatch(sceneReducer.internalActions.addCentralizedPump(nodeId));
    dispatch(systemDataReducerDefineParameters.internalActions.selectDefaultCentralPump(nodeId));
    dispatch(uiReducer.callableActions.selectEntity(nodeId));
}; };
var addTubeConnection = function () { return function (dispatch) {
    var nodeId = "tube-connection-".concat(uuidv4());
    dispatch(sceneReducer.internalActions.addTubeConnection(nodeId));
    dispatch(uiReducer.callableActions.selectEntity(nodeId));
    return nodeId;
}; };
var addEdge = function (fromAttachmentId, toAttachmentId) {
    return function (dispatch) {
        dispatch(addEdges([{ fromAttachmentId: fromAttachmentId, toAttachmentId: toAttachmentId }]));
    };
};
var addEdges = function (attachments) {
    return function (dispatch, getState) {
        var e_2, _a;
        if (getState().systemDataDefineParameters.dataState.isLoading)
            return;
        var systemDataDefineParameters = getState().systemDataDefineParameters.dataState.data;
        if (!systemDataDefineParameters)
            return;
        var unitSystem = getState().ui.unitSystem;
        var initialTubeDiameterIndex = getInitialTubeDiameterIndex(unitSystem, systemDataDefineParameters);
        var edgeId;
        var newEdges = [];
        try {
            for (var attachments_1 = __values(attachments), attachments_1_1 = attachments_1.next(); !attachments_1_1.done; attachments_1_1 = attachments_1.next()) {
                var attachment = attachments_1_1.value;
                var fromAttachmentId = attachment.fromAttachmentId, toAttachmentId = attachment.toAttachmentId;
                edgeId = "edge-".concat(uuidv4());
                newEdges.push({
                    fromAttachmentId: fromAttachmentId,
                    toAttachmentId: toAttachmentId,
                    edgeId: edgeId,
                    unitSystem: unitSystem,
                    initialTubeDiameterIndex: initialTubeDiameterIndex,
                });
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (attachments_1_1 && !attachments_1_1.done && (_a = attachments_1.return)) _a.call(attachments_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        dispatch(sceneReducer.internalActions.addEdges(newEdges));
        dispatch(uiReducer.callableActions.selectEntity(edgeId));
    };
};
var setUnitSystem = function (unitSystem) {
    return function (dispatch, getState) {
        if (getState().systemDataDefineParameters.dataState.isLoading)
            return;
        var systemDataDefineParameters = getState().systemDataDefineParameters.dataState.data;
        if (!systemDataDefineParameters)
            return;
        var edges = getState().scene.present.edges;
        var edgeIds = Object.keys(edges);
        var initialTubeDiameterIndex = getInitialTubeDiameterIndex(unitSystem, systemDataDefineParameters);
        var defaultDiameter = tubeDiameterOptions[unitSystem][initialTubeDiameterIndex].value;
        dispatch(sceneReducer.callableActions.setEdgeDiameterDefaultTube({
            edgeIds: edgeIds,
            diameter: defaultDiameter,
            index: initialTubeDiameterIndex,
        }));
        dispatch(sceneReducer.callableActions.setEdgeDiameterBlowOffTube({
            edgeIds: edgeIds,
            diameter: defaultDiameter,
            index: initialTubeDiameterIndex,
        }));
        dispatch(uiReducer.callableActions.setUnitSystem(unitSystem));
    };
};
var duplicateNode = function (nodeId) {
    return function (dispatch, getState) {
        var _a;
        if (getState().systemDataDefineParameters.dataState.isLoading)
            return;
        var newNodeId = "tube-connection-".concat(uuidv4());
        var sceneState = getState().scene.present;
        if (sceneState.nodes[nodeId].type === NodeComponentType.GRIP_POSITION) {
            newNodeId = "grip-position-".concat(uuidv4());
            dispatch(systemDataReducerDefineParameters.internalActions.assignCupSelection(newNodeId));
            dispatch(systemDataReducerDefineParameters.internalActions.assignCupMountingSelection(newNodeId));
            dispatch(systemDataReducerDefineParameters.internalActions.assignDecentralPumpSelection(newNodeId));
            var hasCupTechnologies = Object.keys(((_a = getState().systemDataDefineParameters.dataState.data) === null || _a === void 0 ? void 0 : _a.cupTechnologySelections) || {}).length > 0;
            if (hasCupTechnologies) {
                dispatch(systemDataReducerDefineParameters.internalActions.assignCupTechnologySelection(newNodeId));
            }
            if (!getState().systemDataDefineParameters.cupSelectionMap[newNodeId] ||
                !getState().systemDataDefineParameters.cupMountingSelectionMap[newNodeId] ||
                (hasCupTechnologies &&
                    !getState().systemDataDefineParameters.cupTechnologySelectionMap[newNodeId]) ||
                !getState().systemDataDefineParameters.pumpSelectionDecentralMap[newNodeId]) {
                dispatch(systemDataReducerDefineParameters.internalActions.unassignAllSelections([newNodeId]));
                return;
            }
            dispatch(systemDataReducerDefineParameters.internalActions.duplicateSelections({
                fromNodeId: nodeId,
                toNodeId: newNodeId,
            }));
        }
        else if (sceneState.nodes[nodeId].type ===
            NodeComponentType.CENTRALIZED_VACUUM_PUMP) {
            newNodeId = "central-pump-".concat(uuidv4());
            dispatch(systemDataReducerDefineParameters.internalActions.assignCentralPumpSelection(newNodeId));
            if (!getState().systemDataDefineParameters.pumpSelectionCentralMap[newNodeId]) {
                return;
            }
            dispatch(systemDataReducerDefineParameters.internalActions.duplicateSelections({
                fromNodeId: nodeId,
                toNodeId: newNodeId,
            }));
        }
        dispatch(sceneReducer.internalActions.duplicateNode({
            fromNodeId: nodeId,
            toNodeId: newNodeId,
        }));
        dispatch(uiReducer.callableActions.selectEntity(newNodeId));
    };
};
var deleteNode = function (nodeId) {
    return function (dispatch, getState) {
        if (getState().systemDataDefineParameters.dataState.isLoading)
            return;
        /* Capture the component selections committed to Tacton for this node
         * before we clear them, so a later undo can re-commit them. These values
         * only live in Tacton/systemData and cannot be recovered from the scene
         * graph that redux-undo restores. */
        dispatch(undoSnapshotsReducer.callableActions.storeSnapshot({
            nodeId: nodeId,
            snapshot: getNodeSelectionSnapshot(getState().systemDataDefineParameters, nodeId),
        }));
        dispatch(systemDataReducerDefineParameters.internalActions.deselectAllComponents([
            nodeId,
        ]));
        dispatch(systemDataReducerDefineParameters.internalActions.unassignAllSelections([
            nodeId,
        ]));
        /* deleteNode is an internalAction so this delete is recorded in the
         * redux-undo history; undo/redo of it is orchestrated by the undo/redo
         * thunks below, which keep Tacton in sync with the scene. */
        dispatch(sceneReducer.internalActions.deleteNode(nodeId));
        dispatch(uiReducer.callableActions.deselectEntities());
    };
};
/* Re-commits a previously deleted node's component selections to Tacton, used
 * when a deleteNode is undone. Re-assigns the selection slots, then commits the
 * snapshot values in a single request. Returns false (and rolls back the
 * assignments) if the slots can't be reserved or Tacton rejects the commit, so
 * the caller can abort without ever touching the scene. */
var restoreNodeSelections = function (nodeId, snapshot) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var assign, rollback, systemData, entries, parameters, values, entries_1, entries_1_1, _a, selectionId, value, _b;
        var e_3, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    assign = systemDataReducerDefineParameters.internalActions;
                    if (snapshot.cup !== undefined)
                        dispatch(assign.assignCupSelection(nodeId));
                    if (snapshot.cupMounting !== undefined)
                        dispatch(assign.assignCupMountingSelection(nodeId));
                    if (snapshot.cupTechnology !== undefined)
                        dispatch(assign.assignCupTechnologySelection(nodeId));
                    if (snapshot.pumpCentral !== undefined)
                        dispatch(assign.assignCentralPumpSelection(nodeId));
                    if (snapshot.pumpDecentral !== undefined)
                        dispatch(assign.assignDecentralPumpSelection(nodeId));
                    rollback = function () { return dispatch(assign.unassignAllSelections([nodeId])); };
                    systemData = getState().systemDataDefineParameters;
                    entries = [
                        { selectionId: systemData.cupSelectionMap[nodeId], value: snapshot.cup },
                        {
                            selectionId: systemData.cupMountingSelectionMap[nodeId],
                            value: snapshot.cupMounting,
                        },
                        {
                            selectionId: systemData.cupTechnologySelectionMap[nodeId],
                            value: snapshot.cupTechnology,
                        },
                        {
                            selectionId: systemData.pumpSelectionCentralMap[nodeId],
                            value: snapshot.pumpCentral,
                        },
                        {
                            selectionId: systemData.pumpSelectionDecentralMap[nodeId],
                            value: snapshot.pumpDecentral,
                        },
                    ];
                    parameters = [];
                    values = [];
                    try {
                        for (entries_1 = __values(entries), entries_1_1 = entries_1.next(); !entries_1_1.done; entries_1_1 = entries_1.next()) {
                            _a = entries_1_1.value, selectionId = _a.selectionId, value = _a.value;
                            if (value === undefined)
                                continue;
                            /* A snapshot value with no free selection slot to hold it means we
                             * cannot faithfully restore the node — abort rather than restore a
                             * partial state. */
                            if (!selectionId) {
                                rollback();
                                return [2 /*return*/, false];
                            }
                            parameters.push(selectionId);
                            values.push(value);
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (entries_1_1 && !entries_1_1.done && (_c = entries_1.return)) _c.call(entries_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    if (parameters.length === 0)
                        return [2 /*return*/, true];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(systemDataReducerDefineParameters.callableActions.setParametersDefineParameters({ parameters: parameters, values: values })).unwrap()];
                case 2:
                    _d.sent();
                    return [2 /*return*/, true];
                case 3:
                    _b = _d.sent();
                    rollback();
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
/* Clears a node's committed selections from Tacton and unassigns its selection
 * slots, used when a deleteNode is redone. Captures a fresh snapshot first so a
 * subsequent undo can restore the node again. Returns false if Tacton rejects
 * the clear, in which case no local state is mutated and the caller can abort. */
var clearNodeSelections = function (nodeId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var systemData, snapshot, idsToClear, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    systemData = getState().systemDataDefineParameters;
                    snapshot = getNodeSelectionSnapshot(systemData, nodeId);
                    idsToClear = getCommittedSelectionIds(systemData, nodeId);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    if (!(idsToClear.length > 0)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(systemDataReducerDefineParameters.callableActions.clearParameters(idsToClear)).unwrap()];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    _a = _b.sent();
                    /* Nothing local has been mutated yet, so the scene and Tacton remain
                     * in sync; let the caller abort the redo. */
                    return [2 /*return*/, false];
                case 5:
                    dispatch(undoSnapshotsReducer.callableActions.storeSnapshot({ nodeId: nodeId, snapshot: snapshot }));
                    dispatch(systemDataReducerDefineParameters.internalActions.unassignAllSelections([
                        nodeId,
                    ]));
                    return [2 /*return*/, true];
            }
        });
    }); };
};
/* Undo that keeps Tacton in sync with the scene graph. A single undoable
 * history entry corresponds to exactly one deleteNode, so at most one node
 * reappears and needs its Tacton selections re-committed. We re-commit first;
 * only if that succeeds do we revert the scene, so the graph and Tacton never
 * drift out of sync. */
var undo = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var state, _a, past, present, target, snapshots, nodeToRestore, restored;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                state = getState();
                if (state.systemDataDefineParameters.dataState.isLoading)
                    return [2 /*return*/];
                _a = state.scene, past = _a.past, present = _a.present;
                if (past.length === 0)
                    return [2 /*return*/];
                target = past[past.length - 1];
                snapshots = state.undoSnapshots.nodeSelections;
                nodeToRestore = Object.keys(target.nodes).find(function (id) { return !present.nodes[id] && snapshots[id]; });
                if (!nodeToRestore) return [3 /*break*/, 2];
                return [4 /*yield*/, dispatch(restoreNodeSelections(nodeToRestore, snapshots[nodeToRestore]))];
            case 1:
                restored = _b.sent();
                if (!restored)
                    return [2 /*return*/];
                _b.label = 2;
            case 2:
                dispatch(UndoActionCreators.undo());
                return [2 /*return*/];
        }
    });
}); }; };
/* Redo counterpart of undo. Redoing a deleteNode removes a node that currently
 * has Tacton selections, so we clear them first and only revert the scene if
 * Tacton accepted the clear. */
var redo = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var state, _a, future, present, target, nodeToDelete, cleared;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                state = getState();
                if (state.systemDataDefineParameters.dataState.isLoading)
                    return [2 /*return*/];
                _a = state.scene, future = _a.future, present = _a.present;
                if (future.length === 0)
                    return [2 /*return*/];
                target = future[0];
                nodeToDelete = Object.keys(present.nodes).find(function (id) {
                    return !target.nodes[id] &&
                        nodeHasAnySelection(state.systemDataDefineParameters, id);
                });
                if (!nodeToDelete) return [3 /*break*/, 2];
                return [4 /*yield*/, dispatch(clearNodeSelections(nodeToDelete))];
            case 1:
                cleared = _b.sent();
                if (!cleared)
                    return [2 /*return*/];
                dispatch(uiReducer.callableActions.deselectEntities());
                _b.label = 2;
            case 2:
                dispatch(UndoActionCreators.redo());
                return [2 /*return*/];
        }
    });
}); }; };
/*
    This action resets all values to Tacton defaults (for example when switching application) by either uncommiting the fields or commit the default
    value for them.

    Parameters in Tacton that are marked as "always committed" are parameters that cannot be uncommited, so instead Piab has added the default value for
    these parameters so that we can instead restore them to that value.
    
    Parameters that are "committed" are parameters that the user has changed/commited, so we need to uncommit these parameters to reset.
*/
var resetParametersToDefault = createAsyncThunk("reset-parameters", function (_, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    var dispatch, getState, parameters, parameterIdsToClear, parameterToSetToDefault;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                dispatch = thunkAPI.dispatch, getState = thunkAPI.getState;
                parameters = (_b = (_a = getState().systemDataDefineParameters) === null || _a === void 0 ? void 0 : _a.dataState.data) === null || _b === void 0 ? void 0 : _b.parameters;
                parameterIdsToClear = parameters
                    ? Object.values(parameters)
                        .filter(function (parameter) { return !parameter.alwaysCommitted; })
                        .filter(function (parameter) { return parameter.committed; })
                        .map(function (parameter) { return parameter.id; })
                    : [];
                parameterToSetToDefault = parameters
                    ? Object.values(parameters).filter(function (parameter) { return parameter.alwaysCommitted && parameter.ovmDefaultValue; })
                    : [];
                if (!(parameterIdsToClear.length > 0)) return [3 /*break*/, 2];
                return [4 /*yield*/, dispatch(systemDataReducerDefineParameters.callableActions.clearParameters(parameterIdsToClear))];
            case 1:
                _c.sent();
                _c.label = 2;
            case 2: return [4 /*yield*/, dispatch(actions.setParametersDefineParameters({
                    parameters: parameterToSetToDefault.map(function (parameter) { return parameter.id; }),
                    values: parameterToSetToDefault.map(function (parameter) { return parameter.ovmDefaultValue; }),
                }))];
            case 3:
                _c.sent();
                return [2 /*return*/];
        }
    });
}); });
var resetScene = function () { return function (dispatch, getState) {
    var nodeIds = Object.keys(getState().scene.present.nodes);
    dispatch(systemDataReducerDefineParameters.callableActions.clearLatestSelectedCup());
    if (nodeIds.length > 1) {
        dispatch(systemDataReducerDefineParameters.internalActions.unassignAllSelections(nodeIds));
        dispatch(sceneReducer.callableActions.clearScene());
        dispatch(uiReducer.callableActions.deselectEntities());
    }
    // restoring attachment points for Feed pressure point
    dispatch(actions.setNodeAttachments({
        nodeId: feedPressurePointNodeId,
        placeholders: [
            {
                name: feedPressurePointPlaceholderName,
                tubeType: TubeType.COMPRESSED_AIR,
            },
        ],
    }));
}; };
var rehydrateSystemState = createAsyncThunk("rehydrate-system", function (_a, thunkAPI) {
    var persistor = _a.persistor;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    thunkAPI.dispatch(resetScene());
                    clearPersistedStorage();
                    persistor();
                    return [4 /*yield*/, rehydrate(thunkAPI)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
});
var loadTemplateSystem = createAsyncThunk("load-template", function (_a, thunkAPI) {
    var templateData = _a.templateData;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, thunkAPI.dispatch(rehydrateSystemState({
                        persistor: function () { return persistTemplate(templateData); },
                    }))];
                case 1:
                    _b.sent();
                    /* There is a problem for templates that do not define which metric system they are defined in.
                        
                        If we are using imperial units locally when loading a template defined in metric units,
                        then the tube diameters indices in the template code will point to the wrong
                        places in our tube diameter options array.
                        
                        The below will default these templates to metric so that we at least don't get any problems for templates defined in metric. */
                    if (!templateData.includes("".concat(uiPersistConfig.key, "="))) {
                        thunkAPI.dispatch(uiReducer.callableActions.setUnitSystem(UnitSystem.METRIC));
                    }
                    return [2 /*return*/];
            }
        });
    });
});
var setParametersSelectApplication = createAsyncThunk("set-parameters-select-application", function (parameters, thunkAPI) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, thunkAPI.dispatch(systemDataReducerSelectApplication.callableActions.setSelectApplicationParameters(parameters))];
            case 1:
                _a.sent();
                return [4 /*yield*/, thunkAPI.dispatch(systemDataReducerDefineParameters.callableActions.getSystemDataDefineParameters())];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
var loadSystemState = function (system) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var pendingSystemState;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(userReducer.callableActions.fetchSystemState({ systemId: system.id }))];
                case 1:
                    _a.sent();
                    pendingSystemState = getState().user.pendingSystemState;
                    if (!pendingSystemState) {
                        return [2 /*return*/, Promise.resolve(false)];
                    }
                    return [4 /*yield*/, dispatch(rehydrateSystemState({
                            persistor: function () {
                                return pendingSystemState.forEach(function (part) {
                                    return persist(part.persistKey, part.data);
                                });
                            },
                        }))];
                case 2:
                    _a.sent();
                    dispatch(userReducer.callableActions.setUserActiveSystem(system));
                    return [2 /*return*/, Promise.resolve(true)];
            }
        });
    }); };
};
var deleteEdge = function (edgeId) {
    return function (dispatch) {
        dispatch(sceneReducer.internalActions.deleteEdge(edgeId));
        dispatch(uiReducer.callableActions.deselectEntities());
    };
};
var selectCup = function (_a) {
    var nodeIds = _a.nodeIds, value = _a.value;
    return function (dispatch, getState) {
        var e_4, _a, e_5, _b;
        var _c, _d, _e;
        dispatch(systemDataReducerDefineParameters.internalActions.selectCup({
            nodeIds: nodeIds,
            value: value,
        }));
        var cupIsSelected = value !== "".concat(ComponentList.SUCTION_CUP, "_X");
        var scene = getState().scene.present;
        var attachmentIds = nodeIds.flatMap(function (nodeId) { var _a; return (_a = scene.nodes[nodeId]) === null || _a === void 0 ? void 0 : _a.attachmentIds; });
        if (!cupIsSelected) {
            if (!attachmentIds)
                return;
            try {
                for (var attachmentIds_1 = __values(attachmentIds), attachmentIds_1_1 = attachmentIds_1.next(); !attachmentIds_1_1.done; attachmentIds_1_1 = attachmentIds_1.next()) {
                    var attachmentId = attachmentIds_1_1.value;
                    var edgeId = (_c = scene.attachments[attachmentId]) === null || _c === void 0 ? void 0 : _c.edgeId;
                    if (!edgeId)
                        continue;
                    dispatch(sceneReducer.internalActions.deleteEdge(edgeId));
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (attachmentIds_1_1 && !attachmentIds_1_1.done && (_a = attachmentIds_1.return)) _a.call(attachmentIds_1);
                }
                finally { if (e_4) throw e_4.error; }
            }
            return;
        }
        var cupData = (_d = getState().systemDataDefineParameters.dataState.data) === null || _d === void 0 ? void 0 : _d.suctionCupComponents[value];
        if (cupData) {
            // A cup counts as round when its two dimensions are within 5% of each
            // other; otherwise it is oblong. Compare short/long side so the check
            // is independent of cup orientation (landscape vs portrait).
            var cupIsRound = Math.min(cupData.width, cupData.height) /
                Math.max(cupData.width, cupData.height) >
                0.95;
            try {
                for (var nodeIds_1 = __values(nodeIds), nodeIds_1_1 = nodeIds_1.next(); !nodeIds_1_1.done; nodeIds_1_1 = nodeIds_1.next()) {
                    var nodeId = nodeIds_1_1.value;
                    var node = getState().scene.present.nodes[nodeId];
                    if (!node)
                        continue;
                    var isGripPosition = node.type === NodeComponentType.GRIP_POSITION;
                    var marker = isGripPosition
                        ? node.component.marker
                        : undefined;
                    // Keep the grip position's marker shape in sync with the cup:
                    // a round cup belongs in a circle marker (an oval marker sized to a
                    // round cup just renders as a degenerate oval), an oblong cup in an
                    // oval marker. Switching the marker must run before the width/height
                    // updates below, because it resets width/height to the marker defaults.
                    if (cupIsRound && marker === GripPositionMarkerId.OVAL) {
                        dispatch(sceneReducer.callableActions.setGripPositionMarker({
                            nodeId: nodeId,
                            marker: GripPositionMarkerId.CIRCLE,
                        }));
                    }
                    else if (!cupIsRound && marker === GripPositionMarkerId.CIRCLE) {
                        dispatch(sceneReducer.callableActions.setGripPositionMarker({
                            nodeId: nodeId,
                            marker: GripPositionMarkerId.OVAL,
                        }));
                    }
                    dispatch(sceneReducer.callableActions.setGripPositionWidth({
                        nodeId: nodeId,
                        width: cupData.width * 1.1,
                    }));
                    var currentMarker = ((_e = getState().scene.present.nodes[nodeId]) === null || _e === void 0 ? void 0 : _e.component).marker;
                    if (isGripPosition && currentMarker === GripPositionMarkerId.OVAL) {
                        dispatch(sceneReducer.callableActions.setGripPositionHeight({
                            nodeId: nodeId,
                            height: cupData.height * 1.1,
                        }));
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (nodeIds_1_1 && !nodeIds_1_1.done && (_b = nodeIds_1.return)) _b.call(nodeIds_1);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
    };
};
var performAutoRouting = function () { return function (dispatch, getState) {
    var state = getState();
    var systemDataDefineParameters = state.systemDataDefineParameters;
    var systemData = systemDataDefineParameters.dataState.data;
    var isSystemCentralized = isCentralizedSystem(systemData);
    var centralPumps = selectCentralizedPumps(state);
    var tubeConnections = selectTubeConnections(state);
    var gripPositions = selectGripPositions(state);
    var feedPressurePoints = selectFeedPressurePoints(state);
    // Ensure each grip position has a cup selection.
    var suctionCups = gripPositions.filter(function (gripPosition) {
        return systemData === null || systemData === void 0 ? void 0 : systemData.suctionCupSelections[systemDataDefineParameters.cupSelectionMap[gripPosition.id]];
    });
    var attachments = selectAttachments(state);
    var edges = selectEdges(state);
    if (isSystemCentralized) {
        var pairsToConnect = getPairsToConnect(feedPressurePoints, centralPumps, tubeConnections, Object.values(attachments), Object.values(edges), TubeType.COMPRESSED_AIR);
        dispatch(addEdges(pairsToConnect));
        var updatedState = getState();
        var updatedAttachments = selectAttachments(updatedState);
        var updatedEdges = selectEdges(updatedState);
        var updatedPairsToConnect = getPairsToConnect(centralPumps, suctionCups, tubeConnections, Object.values(updatedAttachments), Object.values(updatedEdges), TubeType.VACUUM);
        dispatch(addEdges(updatedPairsToConnect));
    }
    else {
        // Ensure each suction cup has a decentralized pump selection.
        var suctionCupsWithPumps = suctionCups.filter(function (node) {
            return systemData === null || systemData === void 0 ? void 0 : systemData.vacuumPumpSelectionsDecentralized[systemDataDefineParameters.pumpSelectionDecentralMap[node.id]];
        });
        var pairsToConnect = getPairsToConnect(feedPressurePoints, suctionCupsWithPumps, tubeConnections, Object.values(attachments), Object.values(edges), TubeType.COMPRESSED_AIR);
        dispatch(addEdges(pairsToConnect));
    }
}; };
export var actions = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, sceneReducer.callableActions), systemDataReducerDefineParameters.callableActions), systemDataReducerSelectApplication.callableActions), systemPerformanceReducer.callableActions), uiReducer.callableActions), userReducer.callableActions), undoSnapshotsReducer.callableActions), { addGripPosition: addGripPosition, addCentralizedPump: addCentralizedPump, addTubeConnection: addTubeConnection, duplicateNode: duplicateNode, deleteNode: deleteNode, undo: undo, redo: redo, addEdges: addEdges, addEdge: addEdge, setUnitSystem: setUnitSystem, deleteEdge: deleteEdge, resetScene: resetScene, resetParametersToDefault: resetParametersToDefault, selectCup: selectCup, checklistActionSelectCup: checklistActionSelectCup, checklistActionAddPump: checklistActionAddPump, rehydrateSystemState: rehydrateSystemState, loadTemplateSystem: loadTemplateSystem, loadSystemState: loadSystemState, performAutoRouting: performAutoRouting, setParametersSelectApplication: setParametersSelectApplication, toggleGraphPanel: toggleGraphPanel });
